module.exports = __webpack_public_path__ + "static/media/shutterstock_547565467.6156eda9.jpg";